<template>
  <b-form-group :label="label">
    <b-form-input
      :size="size"
      :class="inputClasses"
      :state="vState"
      :id="name"
      :name="name"
      :value="time"
      :ref="name"
      type="time"
      @input="updateDateTime($event)"
      @change="emitBlur"
      :readonly="readonly"
      :disabled="disabled"/>
    <b-form-invalid-feedback :id="name">
      <div @click="setFocus">
        {{validationMessage}}
      </div>
    </b-form-invalid-feedback>
  </b-form-group>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    'value': {
      type: String,
      default () {
        return ''
      }
    },
    'inputClasses': {
      type: String,
      default: ''
    },
    'name': String,
    'required': Boolean,
    'v': Object,
    'disabled': {
      type: Boolean,
      default: false
    },
    'readonly': {
      type: Boolean,
      default: false
    },
    'min': {
      type: [String, Boolean],
      default: false
    },
    'max': {
      type: [String, Boolean],
      default: false
    },
    'label': {
      type: String,
      default: ''
    },
    'size': {
      type: String,
      default: ''
    },
    'startOf': {
      type: [String, Boolean],
      default: false
    },
    'endOf': {
      type: [String, Boolean],
      default: false
    }
  },
  methods: {
    getDateTime (date, time) {
      let m = moment(date)
      let d = m.format('YYYY-MM-DDT')
      return moment(d + time, moment.ISO_8601)
    },
    updateDateTime (time) {
      let date = ''
      if (time) {
        let m = moment(this.value, moment.ISO_8601)
        if (m.isValid()) {
          m = this.getDateTime(this.value, time)
        } else {
          m = this.getDateTime(undefined, time)
        }
        date = m.toISOString()
      }
      this.updateInput(date)
    },
    updateInput (value) {
      this.$emit('input', value)
    },
    emitBlur () {
      this.$emit('blur')
    },
    setFocus () {
      this.$el.querySelector('input').focus()
    }
  },
  computed: {
    vState () {
      if (!this.v) {
        return null
      } else {
        return (!this.v.$dirty) ? null : (this.v.$dirty && !this.v.$invalid)
      }
    },
    time () {
      let time = ''
      if (this.value) {
        let m = moment(this.value, moment.ISO_8601)
        if (!m.isValid()) {
          m = this.getDateTime(undefined, this.value)
        }
        time = m.format('HH:mm:ss')
      }
      return time
    },
    validationMessage () {
      let str = ''

      if (this.v) {
        if (!this.v.required) {
          str = 'This field is required'
        }
      }

      return str
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Common/inputTime.vue